export default "__VITE_ASSET__Djbo8am8__"